import { getAttyStatusFromId, getCaseTypeFromId, getGDQStatusNameFromId, getPracticeNameFromId } from "../../../../lib/labels";
import { checkIfLopIsRequired, formatCurrency, formatDateLocal } from "../../../../lib/script";
import { practicesFunctions } from "../../../../lib/practices";

import Pagination from "../pagination/Pagination";
import HeaderCell from "../../cells/HeaderCell";

import classes from '../WorkQComponent.module.css'
import RecordsUploadContainer from "../../../patient/details/recordsUpload/RecordsUploadContainer";
import { useSelector } from "react-redux";
import HeaderCellGroup from "../../cells/HeaderCellGroup";
import MRQStatusCell from "../../cells/MRQStatusCell";
import NameCell from "../../cells/NameCell";
import VerificationBox from "./VerificationBox";
import BodySimpleModalV2 from "../../../common/modal/BodySimpleModalV2";
import NamePhoneCell from "../../cells/NamePhoneCell";
import PracticesUploadItem from "../../../patient/details/procodocs/practicesupload/PracticesUploadItem";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import ExpandCell from "../../cells/ExpandCell";
import TextCellCopy from "../../cells/TextCellCopy";
import DateWithBox from "../../cells/DateWithBox";
import DaysAgoBox from "../../cells/DaysAgoBox";
import WorkQComponentLoading from "./WorkQComponentLoading";
import { getDaysDifferenceAbs } from "../../../../lib/dateScripts";

export default function MedicalRecords({workqSlug, patientsList}) {
    const userToken = useSelector(state => state.user.token)

    return <>
        <WorkQComponentLoading classes={classes}/>  

        {patientsList && <>
            <div className={classes.normal_container}>
                {/* ${loading ? classes.table_body_loading : ''} */}
                <table className={`${classes.custom_table} ${classes.table_align_top} `}>
                    <thead>
                        <tr>
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'Demographic'}}/>                               
                            </th>      
                            <th colSpan={3}>
                                <HeaderCellGroup item={{groupName: 'Case'}} />
                            </th>                   
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'Attorney'}}/>
                            </th>
                            <th colSpan={2}>
                                <HeaderCellGroup item={{groupName: 'GDQ'}} />
                            </th>
                            <th >
                                <HeaderCellGroup item={{groupName: 'MRQ'}} />
                            </th>
                            <th colSpan={10}>
                                <HeaderCellGroup item={{groupName: 'Practices'}}/>
                            </th>
                        </tr>
                        <tr>    
                            {/* demographic  */}
                            <th>
                                <HeaderCell item={{name: 'NG #', group: 'patient', label: 'person_number', sortable: true}} />                                 
                            </th>
                            <th>
                                <HeaderCell item={{name: 'Patient Name', group: 'patient', label: 'name', sortable: true}} />                                 
                            </th> 

                            {/* case  */}
                            <th>
                                <HeaderCell item={{name: 'Type', group: 'case', label: 'case_type_id', sortable: true}} />                                
                            </th>
                            <th className="table-cell-fit">
                                <HeaderCell item={{name: 'Initial treatment', group: 'case', label: 'initial_treatment', sortable: true}} />                                
                            </th> 
                            <th className="table-cell-fit">
                                <HeaderCell item={{name: 'Return to Tx.', group: 'case', label: 'initial_treatment', sortable: false}} />                                
                            </th> 

                            {/* attorney    */}
                            <th>
                                <HeaderCell item={{name: 'Law Firm', group: 'attorney', label: 'law_firm', sortable: true}} />                                 
                            </th>
                            <th>
                                <HeaderCell item={{name: 'Status', group: 'attorney', label: 'status_id', sortable: true}} />                                
                            </th>   

                            {/* gdq    */}
                            <th>
                                <HeaderCell item={{name: 'Status', group: 'case', label: 'gdq_status_id', sortable: true}} />                                 
                            </th>
                            <th>
                                <HeaderCell item={{name: 'Exit Date', group: 'work_queue_gdq_mrq', label: 'gdq_exit_date', sortable: true}} />                                
                            </th>    

                            {/* mrq    */}
                            <th>
                                <HeaderCell item={{name: 'Entry Date', group: 'work_queue_gdq_mrq', label: 'mrq_entry_date', sortable: true}} />                                 
                            </th>
                            {/* <th>
                                <HeaderCell item={{name: 'Days in Q', group: 'work_queue_gdq_mrq', label: 'days_in_q', sortable: false}} />                                
                            </th>    */}


                            {/* Practices */}
                            <th>Practice</th>
                            <th>Chart Number</th>
                            <th>Total Charges</th>                            
                            <th>HIPPA</th>
                            <th>LOP</th>
                            <th>LOR</th>
                            <th>Lien Status</th>
                            <th style={{width: 190}}>MRQ Status</th>
                            <th>Records</th>
                            <th>Upload Date</th>
                        </tr>
                    </thead>
                    <tbody >
                        {patientsList.data && patientsList.data.map(item => (

                            <tr key={item.case?.id}>
                                {/* demographic person #  */}                           
                                <td>
                                    {item.patient && item.patient.person_number && <>                                        
                                        <div className={`${classes.cell_row} ${classes.cell_row_flex}`}>
                                            <TextCellCopy text={item.patient.person_number}/>
                                        </div>
                                    </>}
                                </td>

                                {/* patient name  */}  
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.patient && <>
                                        <NameCell slug={workqSlug} item={item} text={item.patient.name} group={{dob: item.patient.dob}} hideDrawer={true}/>                                
                                    </>}
                                </td>                            

                                {/* case type  */}
                                <td >
                                    {item.case && <>
                                        <div className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.justify_centered}`}>{getCaseTypeFromId(item.case.case_type_id)}</div>
                                    </>}  
                                </td>
                                {/* initial treatment  */}
                                <td>
                                    {item.work_queue_gdq_mrq && <>
                                        <DateWithBox classes={classes} date={item.work_queue_gdq_mrq.gdq_entry_date}/>
                                    </>}
                                </td> 

                                {/* return to treatment  */}
                                <td>
                                    {item.case && <>
                                        <DateWithBox classes={classes} date={item.case.return_for_treatment_date}/>
                                    </>}
                                </td> 

                                {/* attorney law firm  */}
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.attorney && <>
                                        {item.attorney.law_firm && <ExpandCell initialText={item.attorney.law_firm}>
                                            {item.attorney.attorney_name && <div className={classes.expand_cell_row}>
                                                <strong>Atty:</strong> <NamePhoneCell classes={classes} name={item.attorney.attorney_name} phone={item.attorney.attorney_phone} />
                                            </div>}
                                            {item.attorney.case_manager && <div className={classes.expand_cell_row}>
                                                <strong>CM:</strong> <NamePhoneCell classes={classes} name={item.attorney.case_manager} phone={item.attorney.case_manager_phone} />
                                            </div>}
                                        </ExpandCell>}
                                    </>}
                                </td> 

                                {/* atty status  */}
                                <td className={`${classes.td_cell_no_padding} ${!item.attorney && classes.no_data}`}>
                                    {item.attorney && <VerificationBox displayData={getAttyStatusFromId(item.attorney.status_id)} rowData={item} type={'atty'}/>}
                                </td>    


                                {/* GDQ status  */}
                                <td>
                                    {item.case && <>
                                        <div className={`${classes.cell_row} ${classes.cell_row_flex}`}>{getGDQStatusNameFromId(item.case.gdq_status_id)}</div>
                                    </>}
                                </td>
                                <td>
                                    {item.work_queue_gdq_mrq && <>
                                        <DateWithBox classes={classes} date={item.work_queue_gdq_mrq.gdq_exit_date}/>
                                    </>}
                                </td>

                                {/* MRQ status  */}
                                <td>
                                    {item.work_queue_gdq_mrq && <>
                                        <DateWithBox classes={classes} date={item.work_queue_gdq_mrq.mrq_entry_date}/>
                                    </>}
                                </td>

                                {/*  practices  */}
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>{getPracticeNameFromId(practice.practice_id)}</div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>{practice.chart_number}</div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${(practice.mrq_upload && (practice.total_charges != practice.mrq_last_upload_total_charges)) ? classes.red_border : ''} ${classes['height_' + item?.practices?.length]}`}>
                                            {practice.mrq_upload ? 
                                            <BodySimpleModalV2 isFlex={true} normalEvent={true} messages={[`<strong>Total Charges at last upload: </strong> ${practice.mrq_last_upload_total_charges ? `$${formatCurrency(practice.mrq_last_upload_total_charges)}` : '-'}`]} >
                                                ${formatCurrency(practice.total_charges)}
                                            </BodySimpleModalV2>

                                            :

                                            <>${formatCurrency(practice.total_charges)}</>

                                            }
                                        </div>
                                    ))}                                    
                                </td>                                
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.justify_centered} ${classes['height_' + item?.practices?.length]}`}>
                                            {/* <CheckboxCell setStyle={'centered'} checked={practice.has_hippa} isDisabled={true}/> */}
                                            <PracticesUploadItem practiceId={practice.practice_id} usedFor={'HIPAA'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                        </div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.justify_centered} ${classes['height_' + item?.practices?.length]}`}>
                                            {checkIfLopIsRequired(item?.attorney, item) && practicesFunctions.isPracticeRequiresLOP(practice.practice_id) ? (
                                                <PracticesUploadItem practiceId={practice.practice_id} usedFor={'LOP'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                            ) : (
                                                <CheckboxCell checked={practice.has_lop ?? practice.lop} isDisabled={true} setStyle={'centered'}/>
                                            )}
                                        </div>
                                    ))}
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices[0] && <div className={`${classes.practice_cell} ${classes.justify_centered} ${classes.height_1}`}>
                                        <PracticesUploadItem practiceId={item.practices[0].practice_id} usedFor={'LOR'} uploadDisabled={true} caseAttorneyId={item?.attorney?.id} activeCase={item}/>
                                    </div>}                                  
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>
                                            {practice.lien_status}
                                        </div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>
                                            <MRQStatusCell data={practice.mrq_status_id} item={practice} caseData={item} />
                                        </div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes['height_' + item?.practices?.length]}`}>
                                            <RecordsUploadContainer practiceitem={practice} managingAttyId={item?.attorney?.id} userToken={userToken} activeCase={item} docType={item?.attorney?.id ? 'procodocs' : 'document'} forWorkQ={true}/>
                                        </div>
                                    ))}                                    
                                </td>
                                <td className={`${classes.td_cell_no_padding}`}>
                                    {item.practices && item.practices.map(practice => (
                                        <div key={practice.practice_id} className={`${classes.practice_cell} ${classes.cell_row_flex_betwen} ${classes['height_' + item?.practices?.length]}`} >
                                            {practice.mrq_last_upload_date ? <>
                                                {formatDateLocal(practice.mrq_last_upload_date)} 
                                                <DaysAgoBox days={getDaysDifferenceAbs(practice.mrq_last_upload_date)}/>
                                            </>
                                            :
                                            <>-</>
                                            }
                                        </div>
                                    ))} 
                                </td>
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
    
            </div>
            


            {patientsList.meta && <div className={classes.pagination_container}>
                {patientsList  && <Pagination data={patientsList} apiType={workqSlug} />}
            </div>}
        </>}
    </>
}